const initialState = {
    amount: '',
    sheba: 'IR - ',
};
const withdraw = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_WITHDRAW':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default withdraw;
